/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\HrVertical\HrVertical.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Wednesday August 9th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday August 9th 2023 5:06:54 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Styles from "Content/HrVertical/HrVertical.module.css";

function HrVertical() {
    return (
        <div className={`${Styles.hrVertical}`}></div>
    )
}

export default HrVertical;
